import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
} from "../../../utils";

export const getPortServiceDetailsAPI = (data) => {
  return apiGet("/api/port-service", data);
};  

export const addPortServiceDetailsAPI = (data) => {
  return apiPost("/api/port-service", data);
};

export const updatePortServiceDetailsAPI = (params, data) => {
  return apiPut(`/api/port-service/${params.id}`, data);
};

export const deletePortServiceDetailsAPI = (id) => {
  return apiDelete(`/api/port-service/${id}`);
};